/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit'
import counterReducer from 'app/features/counter/counterSlice'
import earnReducer from 'app/features/earn/earnSlice'
import web3Reducer from 'app/features/web3/web3Slice'
import history from 'app/utils/history'
import { connectRouter } from 'connected-react-router'
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  return combineReducers({
    router: connectRouter(history),
    counter: counterReducer,
    web3: web3Reducer,
    earn: earnReducer,
    ...injectedReducers,
  })
}
